import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./config/AppRoutes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function isLoggedIn() {
  return localStorage.getItem("auth");
}
router.beforeEach((to, from, next) => {
  if (to.path.substring(0, 4) == "/api") {
    to.path = to.path.substring(4);
  }

  var user = JSON.parse(localStorage.getItem("user"));
  if (
    user != null &&
    !user.email_verified_at &&
    to.path != "/settings/profile"
  ) {
    next({
      path: "/settings/profile",
      query: { redirect: to.fullPath },
    });
  }

  if (to.matched.some((record) => record.meta.authOnly)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      let roles = to.matched[to.matched.length - 1].meta.roles;
      if (roles == undefined || roles.indexOf(user.role_id) != -1) {
        next();
      } else {
        next({
          path: "/dashboard",
          query: { redirect: to.fullPath },
        });
      }
    }
  } else if (to.matched.some((record) => record.meta.guestOnly)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.

    if (isLoggedIn()) {
      next({
        path: "/dashboard",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    //next(); // make sure to always call next()!
    next({
      path: "/under-construction",
      query: { redirect: to.fullPath },
    });
  }
});

export default router;
